import {
  Component,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  EventEmitter,
} from "@angular/core";
import { AbstractControl, FormControl, FormGroup } from "@angular/forms";
import { MatDatepicker } from "@angular/material/datepicker";

@Component({
  selector: "lhpe-datepicker",
  templateUrl: "./datepicker.component.html",
  styleUrls: ["./datepicker.component.scss"],
})
export class DatepickerComponent implements OnInit {
  @Input() formGroup?: FormGroup;
  @Input() control?: FormControl;
  @Input() placeholder?: string;
  @Input() controlName!: string | number | null;
  @Input() required?: boolean;
  @Input() hideToggle?: boolean;
  @Output() change = new EventEmitter();
  @ViewChild(MatDatepicker) picker!: MatDatepicker<any>;
  formControl: any;

  constructor() {}

  ngOnInit(): void {
    if (!this.placeholder) {
      this.placeholder = "Choose a date";
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.formGroup) {
      this.formControl! = this.formGroup!.get(
        this.controlName as string,
      )! as FormControl;
    } else if (changes.control) {
      this.formControl = this.control!;
    }
  }

  getErrorMessage(formControl: AbstractControl | undefined) {
    if (formControl) {
    }
    return "";
  }

  openPicker() {
    if (this.picker) {
      this.picker.open();
    }
  }

  onChange(event: any) {
    this.change.emit(event);
  }
}
